import { render, staticRenderFns } from "./CustomerCrm.vue?vue&type=template&id=76aefd1a"
import script from "./CustomerCrm.vue?vue&type=script&lang=js"
export * from "./CustomerCrm.vue?vue&type=script&lang=js"
import style0 from "./CustomerCrm.vue?vue&type=style&index=0&id=76aefd1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports